import { API_BASE_URL } from 'src/services/envVariableLoader';
import { LabelsStoreType } from 'src/store/labels/labelsStore.types';

export const getLabels = async (lang: string): Promise<LabelsStoreType> => {
  const response = await fetch(`${API_BASE_URL}/labels/${lang.toLowerCase()}`);
  const formattedData: LabelsStoreType = {};
  await response.json().then((data: [{ label: string; content: string }]) => {
    data.forEach(item => {
      formattedData[item.label] = item.content;
    });
  });
  return formattedData;
};
